import { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import { Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { GridColumns } from '@mui/x-data-grid';
import { Shop } from '../../entities/shop.entity';
import { useFetch } from '../../hooks';
import { Avatar, DataTable } from '../../components';
import MainContainer from '../../components/MainContainer';
import useStyles from './styles';
import useShops from '../../hooks/data/useShops';
import useShopGroups from '../../hooks/data/useShopGroups';
import { useShopContext } from '../../contexts/ShopContext';

interface UpdateButtonProps {
  value: Shop;
}

const UpdateButton = ({ value }: UpdateButtonProps): JSX.Element => {
  const { handleSelectShop } = useShopContext();
  return (
    <IconButton
    onClick={() => handleSelectShop(value)}
    >
      <Edit />
    </IconButton>
  );
};

const headers: GridColumns = [
  {
    field: 'imageUrl',
    headerName: '',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    filterable: false,
    sortable: false,
    width: 62,
    align: 'center',
    hideSortIcons: true,
    renderCell: (value) => <Avatar src={value.row.imageUrl} />,
  },
  { field: 'label', headerName: 'Nome', editable: false, flex: 1 },
  { field: 'labelShopGroup', headerName: 'Grupo', editable: false, flex: 1,
  },
  {
    field: 'isDisabled',
    headerName: 'Status',
    editable: false,
    flex: 1,
    valueGetter: (params) => (params.row.isDisabled ? 'Desabilitado' : 'Habilitado'),
  },
  {
    field: 'action',
    headerName: 'Ações',
    disableColumnMenu: true,
    editable: false,
    disableExport: true,
    disableReorder: true,
    hideable: false,
    filterable: false,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    renderCell: (value) => <UpdateButton value={value.row} />,
    hideSortIcons: true,
  },
];

export const Shops = (): JSX.Element => {
  const styles = useStyles();
  const history = useNavigate();
  const repositoryShops = useShops();
  const repositoryShopGroups = useShopGroups();
  const { data: dataShop, loading: loadingShops } = useFetch(repositoryShops.fetchAll);
  const { data: dataShopGroup, loading: loadingGroups } = useFetch(repositoryShopGroups.fetchAll);
  const [shopTable, setShopTable] = useState<Shop[]>([]);

  useEffect(() => {
    if (dataShop && dataShopGroup) {
      setShopTable(
        dataShop.map(shop => ({
          ...shop,
          labelShopGroup: dataShopGroup.find(shopGroup => shopGroup.id === shop.groupId)?.label ?? 'Sem grupo',
        }))
      );
    }
  }, [dataShop, dataShopGroup]);

  if (loadingShops || loadingGroups) {
    return <></>;
  }

  return (
    <MainContainer>
      <>
      <div className={styles.content}>
        <DataTable
          columns={headers}
          rows={shopTable || []}
          loading={loadingShops || loadingGroups}
          showAddButton
          onClickAdd={() => history('/shops/new')}
        />
      </div>
      </>
    </MainContainer>
  );
};

export default Shops;


